import React, {useState} from 'react';
import {Button, Card, Table, Tag} from "antd";
import {CheckCircleOutlined, ExclamationCircleOutlined, WarningOutlined} from "@ant-design/icons";
import Error from "../../../components/Error";
import NotificationAddModal from "./NotificationAddModal";
import NotificationUpdateModal from "./NotificationUpdateModal";
import {useGetNotificationsQuery} from "../../../slices/rootApiSlices/notificaitonsApiSlice";
import {useSelector} from "react-redux";
import parameterList from "./parameterList";

const NotificationActions = () => {

    const {user} = useSelector(state => state.auth);
    const {data, error, isLoading} = useGetNotificationsQuery(user?.token)
    const [isAddModalVisible, setIsAddModalVisible] = useState(false);
    const [isUpdateModalVisible, setIsUpdateModalVisible] = useState(false);
    const [selectedNotification, setSelectedNotification] = useState(null);

    const handleOpenModal = () => {
        setIsAddModalVisible(true);
    };

    const handleCloseModal = () => {
        setIsAddModalVisible(false);
    };

    const handleUpdateOpenModal = (notification) => {
        setSelectedNotification(notification);
        setIsUpdateModalVisible(true);
    };

    const handleUpdateCloseModal = () => {
        setIsUpdateModalVisible(false);
    };

    const columns = [
        {
            title: 'Araç ID',
            dataIndex: 'vehicle_id',
            key: 'vehicle_id',
            width: '5%',
            responsive: ['sm'],
            sortDirections: ['descend', 'ascend'],
            render: (text, row) => (
                <Button
                    type="link"
                    size="small"
                    onClick={() => handleUpdateOpenModal(row)}
                >
                    {text ? text : '-'}
                </Button>
            ),
        },
        {
            title: 'Araç Plakası',
            dataIndex: 'plateNumber',
            key: 'plateNumber',
            width: '10%',
            responsive: ['sm'],
            sortDirections: ['descend', 'ascend'],
        },
        {
            title: 'Bildirim Türü',
            dataIndex: 'notification_method',
            key: 'notification_method',
            width: '12%',
            render: (text) => {
                if (text === 'push') {
                    return 'Web Push Bildirimi';
                } else if (text === 'email') {
                    return 'E-posta';
                } else {
                    return 'Tanımlanmadı';
                }
            },
        },
        {
            title: 'Parametre',
            dataIndex: 'parameter',
            key: 'parameter',
            width: '8%',
            render: (text) => {
                const parameter = parameterList.find(item => item.value === text);
                return parameter ? parameter.label : 'Geçersiz Parametre';
            },
        },
        {
            title: 'Threshold Değeri',
            dataIndex: 'threshold_value',
            key: 'threshold_value',
            width: '8%',
            render: (value, record) => {
                const parameterUnits = {
                    "actualEnginePercentTorque": "%",
                    "engineSpeed": "RPM",
                    "vehicleSpeed": "km/h",
                    "fuelRate": "litre/saat",
                    "instantaneousFuelEconomy": "km/litre",
                    "actualRetarderPercentTorque": "%",
                    "wheelBasedSpeed": "km/h",
                    "acceleratorPedalPosition": "%",
                    "currentGear": "",
                    "bellowPressFrontAxleLeft": "bar",
                    "bellowPressFrontAxleRight": "bar",
                    "bellowPressRearAxleLeft": "bar",
                    "bellowPressRearAxleRight": "bar",
                    "brakePedalPosition": "%",
                    "steeringWheelAngle": "derece",
                    "fuelLevel": "litre",
                    "engineTotalHoursOfOperation": "saat",
                    "highResVehicleTotalDistance": "km",
                    "engineCoolantTemp": "°C",
                    "ambientAirTemp": "°C",
                    "serviceBrakeAirPressureCircuit1": "bar",
                    "serviceBrakeAirPressureCircuit2": "bar",
                    "LiquetEngineTotalFuelUsed": "litre",
                    "AftertreatmentDieselExhaustFluidTank1Level": "%",
                    "GaseousTotalFuelUsed": "m³",
                    "hybridBatteryPackRemainingCharge": "%"
                };

                if (parameterUnits[record.parameter]) {
                    return <Tag color="blue">{value} {parameterUnits[record.parameter]}</Tag>;
                } else if (value === 1) {
                    return (
                        <Tag icon={<WarningOutlined/>} color="orange">
                            Uyarı
                        </Tag>
                    );
                } else if (value === 2) {
                    return (
                        <Tag icon={<ExclamationCircleOutlined/>} color="red">
                            Arıza
                        </Tag>
                    );
                } else {
                    return <Tag color="blue">Geçersiz</Tag>;
                }
            },
        },
        {
            title: 'Durumu',
            key: 'isActive',
            width: '5%',
            responsive: ['lg'],
            dataIndex: 'isActive',
            render: (text, record) => (
                <span style={{textAlign: "center"}}>
            {
                record.vehicle_id ?
                    record.isActive === true ?
                        <Tag style={{padding: 3, paddingInline: 5, textAlign: "center"}} icon={<CheckCircleOutlined/>}
                             color='green' key={record.isActive}>
                            Aktif
                        </Tag>
                        :
                        <Tag color='volcano' key={record.isActive}>
                            Kapalı
                        </Tag>
                    :
                    <Tag color='volcano' key={record.isActive}>
                        Kapalı
                    </Tag>
            }
        </span>
            ),
        }
    ];


    if (error) {
        return <Error status={error[0]} title={error[0]} subtitle="Lütfen sonra tekrar deneyin."/>
    }


    return (
        <div style={{padding: 15}}>
            <Card
                title="Bildirim İşlemleri"
                size="small"
                type="inner"
                bodyStyle={{padding: 10, height: "auto"}}
                style={{boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', marginBottom: 10}}
                extra={
                    <Button type="link" onClick={handleOpenModal} size="small">
                        + Yeni Bildirim
                    </Button>
                }
            >
                <Table
                    rowKey="id"
                    loading={isLoading}
                    bordered={true}
                    size="small"
                    columns={columns}
                    dataSource={data?.data}
                    error={error}
                />
            </Card>
            <NotificationAddModal visible={isAddModalVisible} onClose={handleCloseModal}/>
            <NotificationUpdateModal visible={isUpdateModalVisible} onClose={handleUpdateCloseModal} data={selectedNotification}/>
        </div>
    );

};

export default NotificationActions;
